module.exports = __webpack_public_path__ + "img/ojfeature1.8e1ed3fc.jpg";